module.exports = __webpack_public_path__ + "static/Moody4-f6015457be7cf3fa2a84c6226b401e95.png";